import { render, staticRenderFns } from "./Consulting.vue?vue&type=template&id=8d8b3134&scoped=true&"
import script from "./Consulting.vue?vue&type=script&lang=js&"
export * from "./Consulting.vue?vue&type=script&lang=js&"
import style0 from "./Consulting.vue?vue&type=style&index=0&id=8d8b3134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b3134",
  null
  
)

export default component.exports